import type { App } from 'vue'
import WhPagination from '@/components/Pagination/index.vue'
export default {
  install(app: App) {
    app.component('WhPagination', WhPagination)
  },
}
